import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { __, __n } from 'i18n-for-browser';

import connect from "react-redux/es/connect/connect";
import TaxItem from "./TaxItemMain";
import TaxesLow from "./TaxesLowMain";
import Scrollbar from 'react-scrollbars-custom';

import { getText, getImageText, getImage, getPoints } from "../../helpers/feedbackHelpers";
/**
 * Import assets
 */
import Belasting1 from "../../assets/img/icons/belasting-1.svg";
import Belasting2 from "../../assets/img/icons/belasting-2.svg";
import Belasting3 from "../../assets/img/icons/belasting-3.svg";
import Belasting4 from "../../assets/img/icons/belasting-4.svg";
import Belasting5 from "../../assets/img/icons/belasting-5.svg";
import VerliesGlobas from "../../assets/img/icons/economy/min-globas.svg";
import WinstGlobas from "../../assets/img/icons/economy/up-globas.svg";
import { ministryIcons } from '../../assets/assets';
import NextStep from "../elements/NextStep";
import config from '../../config';

class Taxes extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  static defaultProps = {
    desktop: false
  };
  constructor(props) {
    super(props);
    this.state = {
      showOtherIncomeDropdown: false,
      showBuitenlandDropdown: false,
      showInterestDropdown: false,
      showBudgetDropdown: false,
    };
  }

  getGroupIcons = (groups = []) => {
    const { schoolClass } = this.props;
    return groups.map((grp, i) => {
      const g = schoolClass.Groups.find(g => g.GroupTheme.color === grp);
      if (g) return <img key={Math.random() + i + 'lolimsorandom'} className={'tax-item-badge'} src={`${config.apiUrl}${g.GroupTheme.badge}`} alt={'badge'} />;
      return null;
    });
  };

  getWinstVerliesEffect = fb => ({
    icon: parseInt(fb.winstverliesglobas, 10) >= 0 ? WinstGlobas : VerliesGlobas,
    title: parseInt(fb.winstverliesglobas, 10) >= 0 ? __('sim_winstglobas') : __('sim_verliesglobas'),
    contentTitle: fb.winstverliesglobas || 0,
    contentUnit: __('sim_miljard'),
  });

  getEffects = fb => {
    const effects = [];
    if (fb.economie) {
      effects.push(this.getWinstVerliesEffect(fb.economie));
    }
    return effects.concat(fb.overigeEffecten.map((oe) => ({
      icon: ministryIcons[oe.ministerie],
      title: __(oe.ministerie),
      contentTitle: getPoints(oe),
      contentUnit: __('sim_punten'),
    })));
  };

  render() {
    const {
      gameState, gameStateInput, feedback
    } = this.props;

    const { myState } = gameStateInput;
    const {
      gameStateSum, gameStateInput: roundGameStateInput,
    } = gameState.roundData;
    const {
      feedbackAB, feedbackBB, feedbackCB, feedbackVVB, feedbackVB,
    } = feedback;

    if (this.props.project.difficulty === 'BASIC') {
      return (
        <TaxesLow
          desktop={this.props.desktop}
          history={this.props.history}
          inheritedState={this.state}
          getGroupIcons={this.getGroupIcons}
          paramsTaxId={this.props.match.params.taxid}
        />
      );
    }

    let {AB_economie, BB_economie} = gameStateSum;
    AB_economie = AB_economie  || Math.round(gameState.totalEconomy * myState.taxDividence);
    BB_economie = BB_economie || (gameState.totalEconomy - AB_economie);

    const buitenland2 = gameStateSum.BL_VVB_globas + gameStateSum.BL_CB_globas + gameStateSum.BL_VB_globas;

    return (
      <div className={'darkBckg taxes-main-container'}>
        <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
        <div className='container taxes'>
          <div className={'taxes-section'}>
            <TaxItem
              history={this.props.history}
              title={__('sim_arbeidsbelasting')}
              video={'https://player.vimeo.com/video/265045525'}
              sliderKey={'arbeidsBelasting'}
              points={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.AB_points}
              globas={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.AB_globas}
              maxValue={100}
              cap={59}
              minValue={1}
              capNotification={__('sim_arbeidsbelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.arbeidsBelasting}
              collaborationValue={myState.samenWerkingAB}
              collaborationKey={'samenWerkingAB'}
              notification={{
                read: feedbackAB.read,
                reference: feedbackAB.id,
              }}
              icon={Belasting1}
              dataList={[{ title: __('sim_lonenwerknemers'), globas: AB_economie }]}
              feedbackData={{
                show: myState.SIMULATION_TAX === 'PROCESSED',
                topData: [{
                  title: __('sim_lonenwerknemers'),
                  value: `${AB_economie} ${__('sim_miljard')}`,
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).arbeidsBelasting} ${__n('sim_procent', 1).toLowerCase()}`,
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.samenWerkingAB)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
hideWhenZero: true,
                  value: `${gameStateSum.BL_AB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_arbeidsbelasting'),
                  value: `${gameStateSum.AB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_besteedbaar_inkomen_werknemers'),
                  value: `${AB_economie - gameStateSum.BL_AB_globas - gameStateSum.AB_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackAB),
                imgDescription: getImageText(feedbackAB, gameState.language),
                description: getText(feedbackAB, gameState.language),
                effects: this.getEffects(feedbackAB),
              }}
              popupId={'dhgvtarbeidsbelasting'}
              showDropdown={this.props.match.params.taxid === 'arbeidsbelasting'}
            />
            <TaxItem
              history={this.props.history}
              title={__('sim_bedrijvenbelasting')}
              sliderKey={'bedrijvenBelasting'}
              points={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.BB_points}
              globas={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.BB_globas}
              maxValue={100}
              cap={34}
              minValue={1}
              buitenLandDialog={buitenland2}
              capNotification={__('sim_bedrijvenbelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.bedrijvenBelasting}
              collaborationValue={myState.samenWerkingBB}
              collaborationKey={'samenWerkingBB'}
              notification={{
                read: feedbackBB.read,
                reference: feedbackBB.id,
              }}
              icon={Belasting2}
              dataList={[{ title: __('sim_winsten_bedrijfseigenaren'), globas: BB_economie }]}
              feedbackData={{
                show: myState.SIMULATION_TAX === 'PROCESSED',
                topData: [{
                  title: __('sim_winsten_bedrijfseigenaren'),
                  value: `${BB_economie} ${__('sim_miljard')}`
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).bedrijvenBelasting} ${__n('sim_procent', 1).toLowerCase()}`
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.samenWerkingBB)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
hideWhenZero: true,
                  value: `${gameStateSum.BL_BB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_bedrijvenbelasting'),
                  value: `${gameStateSum.BB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_besteedbaar_inkomen_bedrijfseigenaren'),
                  value: `${BB_economie - gameStateSum.BL_BB_globas - gameStateSum.BB_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackBB),
                imgDescription: getImageText(feedbackBB, gameState.language),
                description: getText(feedbackBB, gameState.language),
                effects: this.getEffects(feedbackBB),
              }}
              popupId={'dhgvtbedrijvenbelasting'}
              showDropdown={this.props.match.params.taxid === 'bedrijvenbelasting'}
            />
          </div>

          <div className={'taxes-section'}>
            <TaxItem
              history={this.props.history}
              title={__('sim_consumentenbelasting')}
              video={'https://player.vimeo.com/video/265045525'}
              sliderKey={'CBelasting'}
              points={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.C_points}
              globas={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.C_globas}
              maxValue={100}
              cap={34}
              minValue={1}
              capNotification={__('sim_consumentenbelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.CBelasting}
              collaborationValue={myState.CBelastingSW}
              collaborationKey={'CBelastingSW'}
              icon={Belasting3}
              notification={{
                read: feedbackCB.read,
                reference: feedbackCB.id,
              }}
              dataList={[{ title: __('sim_consumptie'), globas: gameState.roundData.lastGameState.OneTimeEffect.CO }]}
              feedbackData={{
                show: myState.SIMULATION_TAX_2 === 'PROCESSED',
                topData: [{
                  title: __('sim_consumptie'),
                  value: `${gameState.roundData.gameStateSum.CO_value} ${__('sim_miljard')}`,
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).CBelasting} ${__n('sim_procent', 1).toLowerCase()}`,
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.CBelastingSW)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
                  hideWhenZero: true,
                  value: `${gameStateSum.BL_CB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_consumentenbelasting'),
                  value: `${gameStateSum.C_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackCB),
                imgDescription: getImageText(feedbackCB, gameState.language),
                description: getText(feedbackCB, gameState.language),
                // TODO: multilanguage and niveau based and icons??
                effects: this.getEffects(feedbackCB)
              }}
              popupId={'dhgvtconsumentenbelasting'}
              showDropdown={this.props.match.params.taxid === 'consumentenbelasting'}
            />
            <TaxItem
              history={this.props.history}
              title={__('sim_mensmilieubelasting')}
              video={'https://player.vimeo.com/video/265045525'}
              sliderKey={'VVBelasting'}
              points={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.VV_points}
              globas={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.VV_globas}
              maxValue={100}
              cap={49}
              minValue={1}
              capNotification={__('sim_mensmilieubelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.VVBelasting}
              collaborationValue={myState.VVBelastingSW}
              collaborationKey={'VVBelastingSW'}
              icon={Belasting4}
              notification={{
                read: feedbackVVB.read,
                reference: feedbackVVB.id,
              }}
              feedbackData={{
                show: myState.SIMULATION_TAX_2 === 'PROCESSED',
                topData: [{
                  title: __('sim_consumptie_schadelijke_producten'),
                  value: `${gameState.roundData.gameStateSum.VV_value} ${__('sim_miljard')}`,
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).VVBelasting} ${__n('sim_procent', 1).toLowerCase()}`,
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.VVBelastingSW)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
                  hideWhenZero: true,
                  value: `${gameStateSum.BL_VVB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_vervuilingsbelasting'),
                  value: `${gameStateSum.VV_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackVVB),
                imgDescription: getImageText(feedbackVVB, gameState.language),
                description: getText(feedbackVVB, gameState.language),
                // TODO: multilanguage and niveau based and icons??
                effects: this.getEffects(feedbackVVB),
              }}
              dataList={[{ title: __('sim_consumptie_schadelijke_producten'), globas: gameState.roundData.lastGameState.OneTimeEffect.VV }]}
              popupId={'mhgvtmensenmilieubelasting'}
              showDropdown={this.props.match.params.taxid === 'mensenmilieubelasting'}
            />
            <TaxItem
              history={this.props.history}
              title={__('sim_vermogenbelasting')}
              video={'https://player.vimeo.com/video/265045525'}
              sliderKey={'VBelasting'}
              points={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.V_points}
              globas={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.V_globas}
              maxValue={100}
              cap={6}
              minValue={0}
              capNotification={__('sim_vermogensbelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.VBelasting}
              collaborationValue={myState.VBelastingSW}
              collaborationKey={'VBelastingSW'}
              icon={Belasting5}
              notification={{
                read: feedbackVB.read,
                reference: feedbackVB.id,
              }}
              feedbackData={{
                show: myState.SIMULATION_TAX_2 === 'PROCESSED',
                topData: [{
                  title: __('sim_totale_vermogen_van_burgers'),
                  value: `${gameState.totalGameStateSum.V_value + gameStateSum.V_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_gekozenbelastingpercentage'),
                  value: `${(roundGameStateInput || {}).VBelasting} ${__n('sim_procent', 1).toLowerCase()}`,
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.VBelastingSW)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
hideWhenZero: true,
                  value: `${gameStateSum.BL_VB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_vermogensbelasting'),
                  value: `${gameStateSum.V_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackVB),
                imgDescription: getImageText(feedbackVB, gameState.language),
                description: getText(feedbackVB, gameState.language),
                // TODO: multilanguage and niveau based and icons??
                effects: this.getEffects(feedbackVB),
              }}
              dataList={[
                { title: __('sim_besparingen_deze_periode'), globas: gameState.roundData.gameStateSum.V_value },
                { title: __('sim_totale_vermogen_van_burgers'), globas: gameState.totalGameStateSum.V_value },
              ]}
              popupId={'dhgvtvermogensbelasting'}
              showDropdown={this.props.match.params.taxid === 'vermogensbelasting'}
            />
          </div>
        </div>
        </Scrollbar>
        <NextStep />
      </div>
    );
  }
}

export default connect(state => state)(Taxes);



// WEBPACK FOOTER //
// ./src/components/desktop/TaxesMain.js